import React from "react";
import { useSelector } from "react-redux";

const NavPagination = ({
  onFirst,
  onPrev,
  onNext,
  onLast,
  paginator,
  lastPage,
}) => {
  const daskMode = useSelector((state) => state.theme.darkMode);

  return (
    <div className="">
      <div
        className="d-flex justify-content-end"
        style={{ minHeight: 50, paddingTop: "0.4rem" }}
      >
        <button
          type="button"
          className="btn btn-sm"
          onClick={onFirst}
          style={{ minWidth: 60 }}
        >
          <i
            className="material-icons"
            style={
              daskMode
                ? { fontSize: "1.1rem", color: "rgb(117, 117, 117)" }
                : { fontSize: "1.1rem" }
            }
          >
            first_page
          </i>
        </button>
        <button
          type="button"
          className="btn btn-sm"
          onClick={onPrev}
          disabled={paginator.page == 1}
        >
          <i
            className="material-icons"
            style={
              daskMode
                ? { fontSize: "1.1rem", color: "rgb(117, 117, 117)" }
                : { fontSize: "1.1rem" }
            }
          >
            navigate_before
          </i>
        </button>
        <button
          type="button"
          className="btn btn-sm"
          onClick={onNext}
          disabled={paginator.page == lastPage}
        >
          <i
            className="material-icons"
            style={
              daskMode
                ? { fontSize: "1.1rem", color: "rgb(117, 117, 117)" }
                : { fontSize: "1.1rem" }
            }
          >
            navigate_next
          </i>
        </button>
        <button
          type="button"
          className="btn btn-sm"
          onClick={onLast}
          style={{ minWidth: 60 }}
        >
          <i
            className="material-icons"
            style={
              daskMode
                ? { fontSize: "1.1rem", color: "rgb(117, 117, 117)" }
                : { fontSize: "1.1rem" }
            }
          >
            last_page
          </i>
        </button>
      </div>
    </div>
  );
};

export default NavPagination;
